module.exports = __webpack_public_path__ + "img/indonesia.d25aa2a9.svg";